import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleDown } from "@fortawesome/free-solid-svg-icons";

const Navigation = ({ setActiveComponent, showNavigation }) => {
  const hadleNavLinkClick = (componentName) => {
    setActiveComponent(componentName);
  };
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = (menu) => {
    setMenuOpen((prevMenuOpen) => ({
      ...prevMenuOpen,
      [menu]: !prevMenuOpen[menu],
    }));
  };

  return (
    <Nav
      defaultActiveKey="/"
      className={`flex-column navigation sidebar-nav ${
        showNavigation ? "slide-left" : "slide-right"
      }`}
    >
      {/* <Nav.Link>Home</Nav.Link> */}
      <Nav.Link onClick={() => toggleMenu("submenuFile")}>
        File
        <FontAwesomeIcon
          icon={menuOpen["submenuFile"] ? faAngleDown : faAngleDown}
          className={`arrow-icon ${
            menuOpen["submenuFile"] ? "ActiveSUBItem" : ""
          }`}
        />
      </Nav.Link>
      <ul className={`submenu ${menuOpen["submenuFile"] ? "open" : ""}`}>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("vessel")}>
            Vessel
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("voyage")}>
            Voyage
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("salesperson")}>
            Sales person
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("country")}>
            Country
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("port")}>Ports</Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("currency")}>
            Currency
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("incoterms")}>
            Incoterms
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("container")}>
            Containers
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("tax")}>Tax</Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("rates")}>Rates</Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("customer")}>
            Customer
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("supplier")}>
            Supplier
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("transactionsclass")}>
            TransactionsClass
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("transactionstype")}>
            TransactionsType
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("paymentmode")}>
            PaymentMode
          </Nav.Link>
        </li>
        {/* Add more submenu items */}
      </ul>
      <Nav.Link onClick={() => toggleMenu("submenuTransactions")}>
        Transactions
        <FontAwesomeIcon
          icon={menuOpen["submenuTransactions"] ? faAngleDown : faAngleDown}
          className={`arrow-icon ${
            menuOpen["submenuTransactions"] ? "ActiveSUBItem" : ""
          }`}
        />
      </Nav.Link>
      <ul
        className={`submenu ${menuOpen["submenuTransactions"] ? "open" : ""}`}
      >
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("bookingcosting")}>
            BookingCosting
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("Bookingmscdetails")}>
            BookingMSCDetails
          </Nav.Link>
        </li>
      </ul>
      {/* <Nav.Link onClick={() => hadleNavLinkClick("voyage")}>Voyage</Nav.Link> */}
      {/* <Nav.Link onClick={() => hadleNavLinkClick("salesperson")}>
        Sales person
      </Nav.Link> */}
      {/* <Nav.Link onClick={() => toggleMenu("submenu1")}>
        Menu Item with Submenu
        <FontAwesomeIcon
          icon={menuOpen["submenu1"] ? faAngleDown : faAngleDown}
          className={`arrow-icon ${
            menuOpen["submenu1"] ? "ActiveSUBItem" : ""
          }`}
        />
      </Nav.Link> */}
      {/* <ul className={`submenu ${menuOpen["submenu1"] ? "open" : ""}`}>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("voyage")}>
            Voyage
          </Nav.Link>
        </li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("voyage")}>
            Voyage
          </Nav.Link>
        </li>
      
      </ul> */}
      {/* <Nav.Link onClick={() => toggleMenu("submenu2")}>
        Menu Item with Submenu
        <span
          className={`submenu-arrow ${menuOpen["submenu2"] ? "rotate" : ""}`}
        ></span>
      </Nav.Link>
      <ul className={`submenu ${menuOpen["submenu2"] ? "open" : ""}`}>
        <li></li>
        <li>
          <Nav.Link onClick={() => hadleNavLinkClick("vessel")}>
            Vessel
          </Nav.Link>
        </li>
      </ul> */}
    </Nav>
  );
};

export default Navigation;
